import React, { FC } from 'react';
import { WithStyle } from '../../utils';
import { IconCaretDown } from '../icon';
import IconCaretUp from '../icon/icons/caret-up';
import {
  DropdownStyled,
  DropdownToggleStyled,
  DropdownMenuStyled,
  DropdownItemStyled,
  DropdownLinkStyled,
} from './dropdown.styled';
import { DropdownItemProps, DropdownLinkProps, DropdownMenuProps, DropdownProps, DropdownToggleProps } from './types';

export const DropdownLink: FC<DropdownLinkProps> & WithStyle = ({ href, onClick, ref, children }) => (
  <DropdownLinkStyled {...{ href, onClick, ref }}>{children}</DropdownLinkStyled>
);

export const DropdownItem: FC<DropdownItemProps> & WithStyle = props => {
  const { children } = props;
  return <DropdownItemStyled>{children}</DropdownItemStyled>;
};

export const DropdownMenu: FC<DropdownMenuProps> & WithStyle = props => {
  const { children } = props;
  return <DropdownMenuStyled active={props.active}>{children}</DropdownMenuStyled>;
};

export const DropdownToggle: FC<DropdownToggleProps> & WithStyle = props => {
  const { children, $color, $borderColor, onClick, $active } = props;

  return (
    <DropdownToggleStyled {...{ onClick, $color, $borderColor }}>
      {children}
      {/* TODO make flexible */}
      {$active ? <IconCaretUp $size={18} $color={$color} /> : <IconCaretDown $size={18} $color={$color} />}
    </DropdownToggleStyled>
  );
};

DropdownToggle.defaultProps = {
  $color: 'primary',
  $borderColor: 'white',
};

export const Dropdown: FC<DropdownProps> & WithStyle = props => {
  const { children } = props;
  return <DropdownStyled>{children}</DropdownStyled>;
};
